import { template as template_b757e897b4514fe38fb035838abfa835 } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import ENV from 'client-portal/config/environment';
import styles from './pagination.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
export default class RequestClinicianSearchPagination extends Component {
    styles = styles;
    get totalPages() {
        return +this.args.meta?.totalPages || 0;
    }
    get showPagination() {
        return this.totalPages > 1;
    }
    get pageNumber() {
        return +this.args.meta?.page?.number || 1;
    }
    get maxWindowStart() {
        let total = this.totalPages;
        if (!total) {
            return 1;
        }
        return Math.max(1, total - (ENV.clinicianSearchPaginationWindowSize - 1));
    }
    get windowStart() {
        let total = this.totalPages;
        let currentPage = this.pageNumber;
        if (!total || total <= ENV.clinicianSearchPaginationWindowSize) {
            return 1;
        }
        let maxStart = this.maxWindowStart;
        let fromPage = (Math.ceil(currentPage / ENV.clinicianSearchPaginationWindowSize) - 1) * ENV.clinicianSearchPaginationWindowSize + 1;
        return Math.min(Math.max(1, fromPage), maxStart);
    }
    get visiblePages() {
        let total = this.totalPages;
        if (!total) {
            return [];
        }
        let start = this.windowStart;
        let end = Math.min(start + ENV.clinicianSearchPaginationWindowSize - 1, total);
        let pages = [];
        for(let p = start; p <= end; p++){
            pages.push(p);
        }
        return pages;
    }
    get showChevrons() {
        return this.totalPages > ENV.clinicianSearchPaginationWindowSize;
    }
    get showLeftChevron() {
        return this.showChevrons && this.windowStart > 1;
    }
    get showRightChevron() {
        return this.showChevrons && this.windowStart < this.maxWindowStart;
    }
    pageButtonClass = (pageNum)=>{
        return pageNum === this.pageNumber ? 'page-button is-current' : 'page-button';
    };
    selectPage = (pageNum, event)=>{
        event?.preventDefault?.();
        if (pageNum === this.pageNumber) {
            return;
        }
        this.args.onPageChange?.(pageNum);
    };
    slideRight = (event)=>{
        event?.preventDefault?.();
        if (!this.showRightChevron) {
            return;
        }
        let nextStart = this.windowStart + ENV.clinicianSearchPaginationWindowSize;
        this.args.onPageChange?.(nextStart);
    };
    slideLeft = (event)=>{
        event?.preventDefault?.();
        if (!this.showLeftChevron) {
            return;
        }
        let prevStart = Math.max(1, this.windowStart - ENV.clinicianSearchPaginationWindowSize);
        let lastInWindow = Math.min(prevStart + ENV.clinicianSearchPaginationWindowSize - 1, this.totalPages);
        this.args.onPageChange?.(lastInWindow);
    };
    static{
        template_b757e897b4514fe38fb035838abfa835(`
    {{#if this.showPagination}}
      <nav
        class={{styles.component}}
        aria-label={{t "booking.clinicianSearch.pagination.navLabel"}}
        data-test-clinician-pagination
      >
        {{#if this.showLeftChevron}}
          <button
            type="button"
            class="chevron-button"
            aria-label={{t "booking.clinicianSearch.pagination.slidePreviousPages"}}
            {{on "click" this.slideLeft}}
            data-test-clinician-pagination-slide-left
          >
            {{svgJar "chevron-left" class="icon" aria-hidden="true"}}
          </button>
        {{/if}}

        {{#each this.visiblePages as |page|}}
          <button
            type="button"
            class={{this.pageButtonClass page}}
            aria-label={{t "booking.clinicianSearch.pagination.pageNumberAria" page=page}}
            {{on "click" (fn this.selectPage page)}}
            data-test-clinician-pagination-page={{page}}
          >
            {{page}}
          </button>
        {{/each}}

        {{#if this.showRightChevron}}
          <button
            type="button"
            class="chevron-button"
            aria-label={{t "booking.clinicianSearch.pagination.slideNextPages"}}
            {{on "click" this.slideRight}}
            data-test-clinician-pagination-slide-right
          >
            {{svgJar "chevron-right" class="icon" aria-hidden="true"}}
          </button>
        {{/if}}
      </nav>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
